import { Menu } from "lucide-react";
import { ReactNode } from "react";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { UserMenu } from "@/components/dashboard/UserMenu";
import { FeedbackDialog } from "@/components/feedback/FeedbackDialog";

interface DashboardHeaderProps {
  title?: string;
  profilePicture?: string;
  firstName?: string;
  leftContent?: ReactNode;
}

export function DashboardHeader({ title, profilePicture, firstName, leftContent }: DashboardHeaderProps) {
  return (
    <header className="sticky top-0 z-40 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="flex h-16 items-center px-4">
        {/* Left section */}
        <div className="flex items-center gap-4 flex-shrink-0">
          <SidebarTrigger>
            <Menu className="h-5 w-5" />
          </SidebarTrigger>
          {leftContent || (title && <h2 className="text-lg font-semibold">{title}</h2>)}
        </div>

        {/* Center branding */}
        <div className="flex-1 flex justify-center">
          <span className="text-2xl font-black bg-gradient-to-r from-secondary to-primary bg-clip-text text-transparent drop-shadow-sm">
            MAS Matrimonial
          </span>
        </div>

        {/* Right section */}
        <div className="flex items-center gap-3 flex-shrink-0">
          <FeedbackDialog />
          <UserMenu
            profilePicture={profilePicture}
            firstName={firstName}
          />
        </div>
      </div>
    </header>
  );
}
